import { Weapon } from "./Weapon.js";

export class Creature {
  constructor(name, health, weapon, armor = 0, isPlayer = false) {
    this.name = name;
    this.health = health;
    this.maxHealth = health;
    this.weapon = weapon;
    this.timer = 0;
    this.isReloading = false;
    this.currentAmmo = weapon.magazineSize || 0;
    this.statusEffects = [];
    this.armor = armor;
    this.isPlayer = isPlayer;
  }

  resetTimers() {
    this.timer = 0;
    this.isReloading = false;
    this.currentAmmo = this.weapon.magazineSize || 0;
    this.statusEffects = [];
  }

  resetCombat() {
    this.timer = 0;
    this.statusEffects = [];
  }

  static createMonster(monsterData) {
    const weapon = Weapon.createRandom(
      monsterData.weapon.subtype,
      monsterData.weapon.material,
      monsterData.minRoll || 1,
      monsterData.maxRoll || 6
    );
    const creature = new Creature(
      monsterData.name,
      monsterData.health,
      weapon,
      weapon.armor || 0
    );
    creature.minRoll = monsterData.minRoll || 1;
    creature.maxRoll = monsterData.maxRoll || 6;
    return creature;
  }
}
